import styles from "./Contact.module.css";
import twitter from "../assets/sns_icon/twitter.png";
import mail from "../assets/sns_icon/mail.png";
import discord from "../assets/sns_icon/discord.png";

type Props = {};

export const Contact = (props: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.title}>Contact</div>
        <div className={styles.buttons}>
          <div
            className={styles.icon}
            onClick={() => window.open("https://x.com/29_Nom", "_blank")}
          >
            <img src={twitter} className={styles.twitter} alt="Twitter icon" />
          </div>
          <div
            className={styles.icon}
            onClick={() =>
              (window.location.href = "mailto:nomu29nomu@gmail.com")
            }
          >
            <img src={mail} className={styles.mail} alt="Mail icon" />
          </div>
          <div
            className={styles.icon}
            onClick={() =>
              window.open("https://discord.gg/7APSmRNGSp", "_blank")
            }
          >
            <img src={discord} className={styles.discord} alt="Discord icon" />
          </div>
        </div>
        <div className={styles.name}>©Nom</div>
      </div>
    </div>
  );
};
